/**
 * SoftKey — equipment-style action button.
 *
 * variant: 'primary' (cyan accent), 'arm' (lime, for "start TX/RX"),
 *          'abort' (red, for "stop"), 'ghost' (no fill).
 */
export type SoftKeyVariant = 'primary' | 'arm' | 'abort' | 'ghost';

export class SoftKey {
  readonly el: HTMLButtonElement;

  constructor(label: string, variant: SoftKeyVariant = 'primary') {
    this.el = document.createElement('button');
    this.el.className = 'soft-key';
    this.el.dataset.variant = variant;
    this.el.type = 'button';
    this.el.innerHTML = `<span class="soft-key__label">${label}</span>`;
  }

  setLabel(label: string): void {
    const span = this.el.querySelector('.soft-key__label');
    if (span) span.textContent = label;
  }

  setVariant(variant: SoftKeyVariant): void {
    this.el.dataset.variant = variant;
  }

  setDisabled(disabled: boolean): void {
    this.el.disabled = disabled;
  }

  onClick(handler: () => void): void {
    this.el.addEventListener('click', handler);
  }
}
